module.exports = __webpack_public_path__ + "media/images/success-img/layer-4-6607a739c3dedf6877fa0db4e9246124.png";